export const navigation = [
  {
    name: 'Usuarios',
    url: '/usuario',
    icon: 'icon-people'
  },
  {
    name: 'Solicitudes de Usuario',
    url: '/solicitudes-usuario',
    icon: 'icon-user'
  },
  {
    name: 'Transacciones',
    url: '/transacciones',
    icon: 'icon-eye'
  },
  {
    name: 'Agregar Administrador',
    url: '/administrador',
    icon: 'fas fa-user-plus'
  }
];
